import requestHelper from '@/utils/requestHelper'

/**
 * 字典表列表查询接口
 * @param params
 */
export async function getDictMapByCodeList(
  params: { dictCodeList: string[] } = { dictCodeList: [] },
) {
  return requestHelper.post('/v4/demand/basis/dict/getDictMapByCodeList', params)
}

/**
 * 记录用户行为习惯
 * @param data
 */
export async function setUserStorage(data = {}) {
  return requestHelper.post('v4/demand/storage/user/set', data)
}

/**
 * 获取用户行为习惯
 * @param data
 */
export async function getUserStorage(data = {}) {
  return requestHelper.post('v4/demand/storage/user/get', data)
}

/**
 * 记录用户行为习惯(绑定企业)
 * @param data
 */
export async function setCompanyStorage(data = {}) {
  return requestHelper.post('v4/demand/storage/company/set', data)
}

/**
 * 获取用户行为习惯(绑定企业)
 * @param data
 */
export async function getCompanyStorage(data = {}) {
  return requestHelper.post('v4/demand/storage/company/get', data)
}

/**
 * 发送短信验证码至手机(注册、忘记密码)
 * @param data
 */
export async function sendVerifyCode(data: any) {
  return requestHelper.post('v4/demand/user/captcha/send', data)
}

/**
 * 发送短信验证码至邮箱(注册、忘记密码)
 * @param data
 */
export async function sendVerifyCodeByEmail(data: any) {
  return requestHelper.post('v4/demand/user/email/captcha/send', data)
}

/**
 * 获取模板列表
 * @param data
 */
export async function getTemplateList(data?: any) {
  // return requestHelper.post('v4/demand/template/search', data)
  return requestHelper.post('v4/demand/template/search/v2', data)
}

/**
 * 模版收藏
 * @param data
 */
export function favorite(data: { id: string; isFavorite: boolean }) {
  return requestHelper.post('/v4/demand/creativity/work/template/update/favorite', data)
}

/**
 * 标签列表模糊查询，返回结果为list,平铺
 * @param params
 */
export function fetchTagFlatList(
  params: { tagName?: string; themeId?: number; dimension?: string } = {},
) {
  return requestHelper.post('/v4/demand/tag/allList', params)
}

/**
 * 查询当前登陆用户已收藏模板编号信息
 * @param data
 */
export function fetchFavoriteIds(data: any = {}) {
  return requestHelper.post('/v4/demand/template/smart/favorite/ids', data)
}

/**
 * 查询行业
 * @param data
 */
export function getIndustryList(data: any = {}) {
  return requestHelper.post('v4/demand/creativity/industry/list', data)
}

/**
 * 查询媒体
 * @param data
 */
export function getMediaList(data: any = {}) {
  return requestHelper.post('v4/demand/creativity/media/option/list', data)
}

/**
 * 下载作品
 * @param data
 */
export function downloadWork(data = {}) {
  return requestHelper.post('v4/demand/file/batch/zip/download/cacheDownloadParams', data)
}
interface File {
  id: string // 数据ID
}
interface FilesHash extends File {
  filesHash: string // 文档hash ID
}

interface FilesUuid extends File {
  filesUuid: string // 文档uuid ID 和文档hash二选一比传
}

export function shareGenerateUrl(data: {
  effectiveTime?: number // 有效期时长毫秒/0永久。事例：1天传参 24 * 60 * 60 * 1000
  files: any[]
  isDownload?: boolean // 是否下载，true 下载，false 不下载
  isWaterMark?: boolean // 是否打水印，true 打水印，false 不打水印
  shareType?: 'CASE' | 'COLLECT_WORKS' | 'DISK' | 'WORK' // 分享类型
}) {
  return requestHelper.post('v4/demand/share/generate', data)
}

/**
 * 获取标签对应的模板数量
 * @param data
 */
export function getTempNumberCount(data: any = {}) {
  return requestHelper.post('v4/demand/template/number/count', data)
}

// ------------------------------------------ 埋点 --------------------------------------------------

/**
 * 立即制作埋点
 * @param data
 */
export function userActionAdd(data: any = {}) {
  return requestHelper.post('v4/demand/user/action/add', data)
}

// 获取协议内容
export async function getProtocol(data: any) {
  return requestHelper.post('v4/demand/user/agreement/get/content', data)
}

// 获取付费金额
export async function getPayInfo(data: any) {
  return requestHelper.post('/v4/demand/payment/get', data)
}

// 作品库与媒体中心上传，从网盘选择
// 网盘选择后，调用移动
export function personalToTeam(data = {}) {
  return requestHelper.post('v4/demand/creativity/pan/personal/to/team', data)
}

// 上传或网盘选择后的同步
export function workPersonal(data = {}) {
  return requestHelper.post('v4/demand/user/works/collect/upload/work/personal', data)
}

// 文件解析接口 uuid换url
export async function getFileInfoV2(data: any) {
  return requestHelper.post('v4/demand/creativity/pan/file/info', data)
}

// 合作信息收集
export async function getCooperationInfos(data: any) {
  return requestHelper.post('v4/cm/open/coorperate/info/add', data)
}

// 判断当前用户是否已授权广告账号
export function accountExists(data: any = {}) {
  return requestHelper.post('v4/demand/media/advertiser/account/exists', data)
}

// 用户所属签约主体列表（列表+是否可创建新主体）
export function getCorporationList(data: any = {}) {
  return requestHelper.post('v4/demand/company/user/corporation/list/leads', data)
}

// 切换用户主体,返回权限
export function getCorporationChange(data: { corporationId: number } = { corporationId: 0 }) {
  return requestHelper.post('v4/demand/company/user/corporation/change', data)
}

/**
 * 查询行业-品类、投放媒体、地区-国家信息
 * @param data
 * @returns
 */
export function getAdBasisInfo(data: any = {}) {
  return requestHelper.post('v4/demand/template/ad/basis/info', data)
}

/**
 * 查询投放地区\广告目标信息
 * @returns
 */
export function getTargetAreaList() {
  return requestHelper.get('v4/demand/creative/data/analysis/media/target/area/list')
}

/**
 * 用户引导信息是否完全
 * @param data
 */
export function checkGuideTagSave(data: any = {}) {
  return requestHelper.post('v4/demand/guide/tag/list', data)
}

/**
 * 批量翻译
 * @param data
 * @returns
 */
export function batchTranslate(data = {}) {
  return requestHelper.post('v4/demand/ai/subtitle/batch', data)
}

// 获取用户绑定的消息通道
export async function getUserBindSession(data = {}) {
  return requestHelper.post('v4/demand/user/mqtt/bind/session', data)
}

/**
 * 获取模板详情
 * @param params
 */
export function getTmpInfo(params: { templateNumber?: string } = {}) {
  return requestHelper.post('v4/demand/template/info', params)
}

/**
 * 是否需要滑块验证码接口
 * @param data
 * @returns
 */
export function checkValidate(data = {}) {
  return requestHelper.post('v4/demand/user/check/validate', data)
}

/**
 * 活动任务奖励领取
 * @param data
 * @returns
 */
export function getTaskClaimReward(data: {
  taskId?: number // 任务ID
  taskCode?: string // 任务编号 works20
}) {
  return requestHelper.post('v4/demand/activity/task/claimReward', data)
}

/**
 * 活动任务查询
 * @param data
 * @returns
 */
export function getActivityTaskInfo(data: {
  taskCode?: string // 任务编号 works20
  status?: number[] // 0 未完成， 1 已完成未领取，2 已完成已领取, 3 已失效
}) {
  return requestHelper.post('v4/demand/activity/task/info', data)
}

/**
 * 查询用户CNY、CBC钱包余额
 * @param data
 * @returns
 */
export function getWalletAllBalance(data: {}) {
  return requestHelper.post('v4/demand/wallet/all/balance', data)
}

/**
 * 商机收集
 * @param data
 */
export function businessInfoAdd(data: any = {}) {
  return requestHelper.post('v4/cm/open/business/info/add', data)
}

/**
 * 发送短信验证码至手机,普通业务
 * @param data
 */
export async function userCaptchaSend(data: {
  phone: string
  sendType: string
  validate?: string
}) {
  return requestHelper.post('v4/cm/user/captcha/send', data)
}

/**
 * 企业名称模糊查询
 * @param params
 * @returns
 */
export function companyNameSearch(params = {}) {
  return requestHelper.get('v4/demand/company/info/vague/search/by/name', { params })
}

/**
 * im打开权限校验
 * @param data
 * @returns
 */
export function imGroupJoinValidate(data: any = {}) {
  return requestHelper.post('v4/demand/task/order/im/group/join', data)
}
